<template lang="pug">
aiq-dialog.modal-edit-command(title="Edit Command",
        v-model="modalShown"
        :show-close="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        @closed="closeEditor"
        v-on="$attrs")
    aiq-command-builder(:command="command"
            @cancel="closeEditor"
            @updated="(data) => $emit('updated', data)"
            :is-delete-button-visible="false")
</template>

<script>
import aiqCommandBuilder from './AIQCommandBuilder.vue';

export default {
  name: 'aiqCommandBuilderDialog',
  emits: ['close', 'updated'],
  props: {
    command: {
      type: Object,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    aiqCommandBuilder,
  },
  data() {
    return {
      modalShown: false,
      isBusy: false,
    };
  },
  watch: {
    isVisible: {
      handler(newVal) {
        this.modalShown = newVal;
        this.isBusy = false;
      },
      immediate: true,
    },
  },
  methods: {
    closeEditor() {
      this.modalShown = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>